// src/services/fileExportService.js
// 78차 39차: 신규 — 웹 버전(매장관리자 URL 접속)에서 엑셀 업로드/다운로드가 전부 깨져
// 있던 버그를 고치며 분리한 공용 헬퍼. 원인: expo-file-system의 새 File/Paths API와
// expo-sharing은 웹에서 사실상 빈 스텁이다 —
//   - expo-file-system 웹 구현: File 생성자가 그냥 console.warn만 하고 아무 것도 안 함
//     (.write()/.bytes() 같은 메서드 자체가 없음 — 호출하면 TypeError).
//   - expo-sharing 웹 구현: navigator.share가 없으면(대부분의 데스크톱 브라우저) 아무
//     일도 없이 조용히 끝남 — 버튼을 눌러도 아무 반응이 없는 것처럼 보임.
// 그래서 웹에서는 표준 브라우저 API(Blob + <a download>, File.arrayBuffer())로 직접
// 처리하고, 네이티브(iOS/Android)는 기존 방식(File/Paths + Sharing) 그대로 유지한다.
import { Platform } from 'react-native';
import { File, Paths } from 'expo-file-system';
import * as Sharing from 'expo-sharing';

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// XLSX 바이트(Uint8Array)를 파일로 저장하고 공유/다운로드까지 진행
export async function saveAndShareXlsx(bytes, filename) {
  if (Platform.OS === 'web') {
    const blob = new Blob([bytes], { type: XLSX_MIME });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return;
  }
  const file = new File(Paths.cache, filename);
  file.write(bytes);
  if (await Sharing.isAvailableAsync()) {
    await Sharing.shareAsync(file.uri, { mimeType: XLSX_MIME, UTI: 'org.openxmlformats.spreadsheetml.sheet' });
  }
}

// expo-document-picker 결과 asset에서 실제 파일 바이트를 읽음(웹은 브라우저 File 객체의
// arrayBuffer()를 직접 사용 — asset.file은 web 전용으로 document-picker가 넣어주는 필드).
export async function readPickedFileBytes(asset) {
  if (Platform.OS === 'web' && asset.file) {
    const buf = await asset.file.arrayBuffer();
    return new Uint8Array(buf);
  }
  return new File(asset.uri).bytes();
}
